import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { MSpinner } from "components/Shared";
import { get } from "lodash";
import {
  ContactInformation,
  SpecialAttentionNotes,
  InspectionComments,
  Address,
} from "components/QualityAssurance";
import OrderInformation from "components/Homeowner/CaseDetails/OrderInformation";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";
import { Cell } from "react-md";
import NotFoundPage from "components/NotFoundPage";
import { NOT_PROVIDED } from "typeConstants/stringConstants";
import { GetDisplayFieldValue } from "components/Shared/Formatters";
import AppointmentInformation from "components/Homeowner/CaseForms/AppointmentInformation";
import AppraiserAssignmentApproval from "components/Homeowner/CaseForms/AppraiserAssignmentApproval";
import {
  CASE_HISTORY_LIST_VIEW,
  QA_REJECTION_CARD_VIEW,
  CASE_PROPERTY_HISTORY_VIEW,
  CASE_PROPERTY_HISTORY_VIEW_LIMITED,
  CASE_HISTORY_INTERNAL_NOTES_VIEW,
  APPRAISAL_ASSIGNMENT_APPROVAL_VIEW,
  APPRAISAL_ASSIGNMENT_APPROVAL_EDIT,
  CASE_FR_SCHEDULE_VIEW,
  CASE_APPRAISER_SCHEDULE_VIEW,
  QA_CASE_AUDIT_VIEW
} from "typeConstants/rights";
import CaseHazards from "components/QualityAssurance/Sections/Outline/CaseHazards";
import QATouches from "components/QualityAssurance/Sections/Outline/QATouches";
import CaseStepper from "components/Homeowner/CaseStepper";
import { STATUS_TRACKER } from "components/Homeowner/CaseStepper/StepTypes";
import CaseRejections from "components/Homeowner/CaseForms/Actions/CaseRejections";
import PropertyCaseHistory from "components/Homeowner/CaseForms/PropertyCaseHistory";
import { getCaseHeader, updateCaseHeader } from "actions/homeowner/caseforms";
import { getMinimalInspectorListByCase } from "actions/homeowner/fieldReps";
import PublicPropertyRecord from "./PublicPropertyRecord";
import CompactHistory from "components/Homeowner/History/CompactHistory";
import { isCustomer, getCaseType } from "components/Shared/Functions";
import { getCaseLinksRedux, getCaseLinksLimitedRedux } from "requests/homeowner/ho/index";
import { userHasRight, userHasAnyRight } from "selectors/rights";
import CaseRecommendations from "components/QualityAssurance/Sections/Outline/CaseRecommendations";
import FieldRepAvailabilityView, { frScheduleStatusList } from "components/Homeowner/CaseForms/FieldRepAvailabilityView.tsx";
import AppraiserAvailabilityView, { AppraiserAvailabilityViewStatusCodes } from "components/Homeowner/CaseForms/AppraiserAvailabilityView";
import { caseTypes } from "components/Utility/Objects";
import QaCaseAuditWarning from 'components/CaseAudits/QaCaseAuditWarning';
import ComparisonChart from "components/QualityAssurance/Sections/Outline/ComparisonChart.tsx";

class CaseHeader extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.appraiserContactInfo;
    this.brokerContactInfo;
    this.renderAppraisalQaRejection = this.renderAppraisalQaRejection.bind(this);
    this.rejectionExpanderClicked = this.rejectionExpanderClicked.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.getCellSize = this.getCellSize.bind(this);
    this.getFRList = this.getFRList.bind(this);
    this.getHistoryControl = this.getHistoryControl.bind(this);
    this.getCasePropertyHistory = this.getCasePropertyHistory.bind(this);
    this.state = {
      rejectionExpanded: false,
      visibleDialog: false,
      enabledTooltip: ""
    };
  }

  // will get the case header fr list only once
  // The parent components that call caseheader handle how its rendered differently
  // So checking if FR list is loaded in both componentDidMount and componentDidUpdate
  componentDidMount() {
    const { controlNumber } = this.props;
    this.getFRList(controlNumber);
    if (controlNumber) this.getCasePropertyHistory();
  }

  componentDidUpdate(prevProps) {
    const { controlNumber, getCaseHeader } = this.props;
    if (controlNumber !== prevProps.controlNumber) {
      this.getCasePropertyHistory();
      getCaseHeader(controlNumber);
      this.getFRList(controlNumber);
    }
  }

  getCasePropertyHistory() {
    const { controlNumber, canViewCasePropertyHistory, canViewCasePropertyHistoryLimited, getCaseLinks, getCaseLinksLimited } = this.props;
    if (canViewCasePropertyHistory) {
      getCaseLinks(controlNumber);
    } else if (canViewCasePropertyHistoryLimited) {
      getCaseLinksLimited(controlNumber);
    }
  }

  getFRList() {
    if (this.props.caseHeader
      && this.props.caseHeader.canUserEdit
      && !this.props.isFetchingFRList) {
      this.props.getFRList(this.props.controlNumber);
    }
  }

  renderAppraisalQaRejection() {
    const { roles, caseHeader } = this.props;
    if (isCustomer(roles)) {
      return null;
    }
    let showAppraiserRejection =
      caseHeader.caseInfo.hasAppraisalSurveyInfo &&
      caseHeader.caseInfo.appraisalSurveyInfo?.appraiserRejectionCount > 0;
    if (!showAppraiserRejection) return "";

    return (
      <CaseRejections
        qaExpanded={this.state.rejectionExpanded}
        expanderClicked={this.rejectionExpanderClicked}
        controlNumber={caseHeader.caseInfo.appraisalSurveyInfo?.id}
        unresolvedAppraiserRejectionCount={caseHeader.caseInfo.appraisalSurveyInfo?.unresolvedAppraiserRejectionCount}
        viewOnly={false}
      />
    );
  }

  getHistoryControl() {
    return <CompactHistory controlNumber={this.props.controlNumber} viewInternalNotesInput={this.props.viewInternalNotesInput}  />;
  }

  rejectionExpanderClicked(val) { this.setState({ rejectionExpanded: val }); }
  getCellSize(requestedSize) { return this.props.verticalDisplay ? 12 : requestedSize; }
  hide() { this.setState({ visibleDialog: false }); }
  show() { this.setState({ visibleDialog: true }); }

  render() {
    const {
      controlNumber,
      fetchingHeader,
      caseHeader,
      showHistory,
      displayAddressMap,
      caseStepper,
      navigateToCase,
      openCaseTab,
      verticalDisplay,
      qaTouches,
      FRList,
      getCaseHeader,
      updateCaseHeader,
      updatingCaseHeader,
      caseLinks,
      fetchingCaseLinks,
      showFRScheduleView,
      showAppraiserScheduleView,
      hasCaseAuditViewPermission
    } = this.props;
    const { caseInfo, policyInfo } = caseHeader;
    if (fetchingHeader || !policyInfo) { return <MSpinner />; }
    const { surveyAddress, mailingAddress, customerInfo, caseAttributes, orderCodeOut } = policyInfo;
    const { customerName, customerType } = customerInfo;
    if (!caseHeader.policyInfo) { return <NotFoundPage />; }

    let webNotes = caseInfo.webNotes;
    if (webNotes != null && webNotes.length > 0) {
      webNotes = webNotes.replace(/(?:\r\n|\r|\n)/g, "<br />");
    } else {
      webNotes = NOT_PROVIDED;
    }

    let surveyRemarks = caseHeader.policyInfo.surveyRemarks;
    if (surveyRemarks != null && surveyRemarks.length > 0) {
      surveyRemarks = surveyRemarks.replace(/(?:\r\n|\r|\n)/g, "<br />");
    } else {
      surveyRemarks = NOT_PROVIDED;
    }

    let caseType = getCaseType(customerType);

    const reportType = GetDisplayFieldValue(caseHeader.displayFields, "ReportType");

    const frScheduleViewNeeded = frScheduleStatusList.includes(caseInfo.webStatus);

    const appraiserScheduleViewNeeded = caseType === caseTypes.valuation
      && AppraiserAvailabilityViewStatusCodes.includes(caseInfo?.appraisalSurveyInfo?.workflowStatusCode);

    return (
      <div id={caseHeader.wrappableId} className="case-header md-grid md-grid-cards no-padding">
        {showFRScheduleView && frScheduleViewNeeded &&
          <Cell size={this.getCellSize(12)} tabletSize={12} phoneSize={12}>
            <FieldRepAvailabilityView controlIdNumber={controlNumber} />
          </Cell>
        }
        {showAppraiserScheduleView && appraiserScheduleViewNeeded &&
          <Cell size={this.getCellSize(12)} tabletSize={12} phoneSize={12}>
            <AppraiserAvailabilityView controlIdNumber={controlNumber} />
          </Cell>
        }
        <Cell size={this.getCellSize(12)} tabletSize={12} phoneSize={12} className={!caseStepper.trackerActive ? "case-stepper-disabled" : ""}>
          <CaseStepper
            controlNumber={controlNumber}
            stepType={STATUS_TRACKER}
            navigateToCase={navigateToCase}
            openCaseTab={openCaseTab}
          />
        </Cell>
        {hasCaseAuditViewPermission &&
          <QaCaseAuditWarning controlNumber={controlNumber}
        />}
        <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
          <OrderInformation
            controlNumber={controlNumber}
            {...{ reportType }}
            originalSurveyType={caseHeader.caseInfo.originalInspectionType.name}
            policyOrLoanNumber={GetDisplayFieldValue(caseHeader.displayFields, "PolicyNumber")}
            trackingNumber={GetDisplayFieldValue(caseHeader.displayFields, "TrackingNumber")}
            assignmentType={caseAttributes.transactionType}
            customerNumber={customerInfo.customerNumber}
            customerName={customerName}
            orderedDate={GetDisplayFieldValue(caseHeader.displayFields, "DateOrdered")}
            completedDate={GetDisplayFieldValue(caseHeader.displayFields, "DateCompleted")}
            caseType={caseType}
            primaryStatus={GetDisplayFieldValue(caseHeader.displayFields, "PrimaryStatus")}
            webStatus={GetDisplayFieldValue(caseHeader.displayFields, "WebStatus")}
            AppraisalStatus={GetDisplayFieldValue(caseHeader.displayFields, "AppraisalStatus")}
            customerDueDate={GetDisplayFieldValue(caseHeader.displayFields, "CustomerDueDate")}
            showAsTwoColumn={!verticalDisplay}
            legacyDataEntryPageLink={caseHeader.legacyDataEntryPageLink}
            surveyDate={GetDisplayFieldValue(caseHeader.displayFields, "DateSurveyed")}
            returnedDate={GetDisplayFieldValue(caseHeader.displayFields, "DateReturned")}
            orderCodeOut={orderCodeOut}
            governmentSponsor={caseInfo.appraisalSurveyInfo?.governmentSponsor || caseAttributes.gse}
            coverageAIn={caseHeader.policyInfo.coverageAIn}
            coverageAOut={caseHeader.policyInfo.coverageAOut}
            percentITV={caseHeader.policyInfo.percentITV}
            channel={caseAttributes.channel}
            stampsAndPhotoRequirementsLink={caseInfo.stampsAndPhotoRequirementsLink}
            cubiCasaStatus={caseHeader.caseInfo.cubiCasaStatus}
          />
        </Cell>
        {qaTouches &&
          <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
            <QATouches qaTouches={qaTouches} />
          </Cell>
        }
        <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
          <PublicPropertyRecord controlNumber={controlNumber} />
        </Cell>
        {caseInfo.hasHazards &&
          <Cell size={12}>
            <CaseHazards controlNumber={controlNumber} />
          </Cell>}
        {caseInfo.hasRecommendations &&
        <Cell size={12}>
          <CaseRecommendations controlNumber={controlNumber} />
        </Cell>}
        {caseInfo.hasComparisonFields &&
          <Cell size={12}>
            <ComparisonChart controlNumber={controlNumber} />
          </Cell>}
        <Cell size={this.getCellSize(4)} tabletSize={12} phoneSize={12}>
          <ContactInformation
            controlNumber={controlNumber}
            {...{ reportType }}
            borrower={{
              name: policyInfo.policyHolderInfo.policyholderName.fullName,
              firstName: policyInfo.policyHolderInfo.policyholderName.firstName,
              lastName: policyInfo.policyHolderInfo.policyholderName.lastName,
              homePhone: policyInfo.policyHolderInfo.policyholderPhoneHome,
              workPhone: policyInfo.policyHolderInfo.policyholderPhoneWork,
              email: policyInfo.policyHolderInfo.policyholderEmail
            }}
            policyholder={{
              name: policyInfo.policyHolderInfo.policyholderName.fullName,
              firstName: policyInfo.policyHolderInfo.policyholderName.firstName,
              lastName: policyInfo.policyHolderInfo.policyholderName.lastName,
              homePhone: policyInfo.policyHolderInfo.policyholderPhoneHome,
              workPhone: policyInfo.policyHolderInfo.policyholderPhoneWork,
              email: policyInfo.policyHolderInfo.policyholderEmail,
              designatedContactName: policyInfo.policyHolderInfo.designatedContactName,
              designatedContactPhone1: policyInfo.policyHolderInfo.designatedContactPhone1,
              designatedContactPhone2: policyInfo.policyHolderInfo.designatedContactPhone2,
              designatedContactEmail: policyInfo.policyHolderInfo.designatedContactEmail,
            }}
            fieldRep={{
              name: caseInfo.assignedTo,
              number: caseInfo.inspectorNumber,
              workPhone: null,
              mobilePhone: caseInfo.inspectorCellPhone,
              homePhone: caseInfo.inspectorHomePhone,
              email: caseInfo.inspectorEmailAddress
            }}
            appraiser={{
              name: caseInfo.appraiserAssigned,
              number: caseInfo.appraiserNumber,
              workPhone: caseInfo.appraiserWorkPhone,
              mobilePhone: caseInfo.appraiserMobilePhone,
              homePhone: caseInfo.appraiserHomePhone,
              email: caseInfo.appraiserEmailAddress,
              personalEmail: caseInfo.appraiserPersonalEmailAddress,
              allowsEdits: caseInfo.appraiserAllowsEdits,
              appraiserId: caseInfo.appraiserId,
              internetUserId: caseInfo.appraiserInternetUserId,
            }}
            broker={caseInfo.broker && { name: caseInfo.broker.fullName, email: caseInfo.broker.email, phoneNumber: caseInfo.broker.phoneNumber }}
            caseAgent={policyInfo.caseAgentInfo && {
              name: policyInfo.caseAgentInfo.agentName,
              workPhone: policyInfo.caseAgentInfo.agentPhone,
              code: policyInfo.caseAgentInfo.code,
            }}
            agent={policyInfo.agencyInfo && {
              name: policyInfo.agencyInfo.agentName,
              workPhone: policyInfo.agencyInfo.agentPhone,
              email: policyInfo.agencyInfo.email,
              code: policyInfo.agencyInfo.code,
            }}
            lenderDirector={caseInfo.lenderDirector && {
              name: caseInfo.lenderDirector.name,
              workPhone: caseInfo.lenderDirector.workPhone,
              email: caseInfo.lenderDirector.email,
            }}
            lenderManager={caseInfo.lenderManager && {
              name: caseInfo.lenderManager.name,
              workPhone: caseInfo.lenderManager.workPhone,
              email: caseInfo.lenderManager.email,
            }}
            fieldSurveyCoordinator={caseInfo.fieldSurveyCoordinator && {
              name: caseInfo.fieldSurveyCoordinator.name,
              workPhone: caseInfo.fieldSurveyCoordinator.workPhone,
              email: caseInfo.fieldSurveyCoordinator.email,
            }}
            fieldSurveyDirector={caseInfo.fieldSurveyDirector && {
              name: caseInfo.fieldSurveyDirector.name,
              workPhone: caseInfo.fieldSurveyDirector.workPhone,
              email: caseInfo.fieldSurveyDirector.email,
            }}
            valuationCoordinator={caseInfo.valuationCoordinator && {
              name: caseInfo.valuationCoordinator.name,
              workPhone: caseInfo.valuationCoordinator.workPhone,
              email: caseInfo.valuationCoordinator.email,
            }}
            valuationDirector={caseInfo.valuationDirector && {
              name: caseInfo.valuationDirector.name,
              workPhone: caseInfo.valuationDirector.workPhone,
              email: caseInfo.valuationDirector.email,
            }}
            qaDirector={caseInfo.qaDirector && {
              name: caseInfo.qaDirector.name,
              email: caseInfo.qaDirector.email,
            }}
            caseType={caseType}
            isEditable={caseHeader.canUserEdit}
            updateCaseHeader={updateCaseHeader}
            FRList={FRList}
            caseStatus={caseInfo.primaryStatus}
            getCaseHeader={getCaseHeader}
            canChangeAppraiserAssignment={get(caseInfo, ["appraisalSurveyInfo", "canChangeAppraiserAssignment"])}
            underwriterCode={policyInfo.underwriterInfo && policyInfo.underwriterInfo.code}
            enabledFeatures={this.props.enabledFeatures}
            completedDate={GetDisplayFieldValue(caseHeader.displayFields, "DateCompleted")}
          />
        </Cell>
        <Cell size={this.getCellSize(4)} tabletSize={12} phoneSize={12}>
          <Address
            controlNumber={controlNumber}
            mailingProps={{
              address: GetDisplayFieldValue(caseHeader.displayFields, "MailingAddress"),
              county: GetDisplayFieldValue(caseHeader.displayFields, "MailingCounty"),
              rawAddress: mailingAddress,
            }}
            subjectProps={{
              address: GetDisplayFieldValue(caseHeader.displayFields, "SurveyAddress"),
              county: GetDisplayFieldValue(caseHeader.displayFields, "County"),
              state: GetDisplayFieldValue(caseHeader.displayFields, "SurveyState"),
              geocode: GetDisplayFieldValue(caseHeader.displayFields, "GeoCode"),
              rawAddress: surveyAddress,
            }}
            update={updateCaseHeader}
            isUpdating={updatingCaseHeader}
            isEditable={caseHeader.canUserEdit}
            getData={getCaseHeader}
            onAddressClick={displayAddressMap}
          />
        </Cell>
        <Cell size={this.getCellSize(4)} tabletSize={12} phoneSize={12}>
          <AppointmentInformation
            appointmentDateTime={caseInfo.appointmentDateTime}
            appointmentRequired={caseInfo.appointmentRequired}
            appointmentNotes={caseInfo.appointmentNotes}
            appointmentChanged={caseInfo.appointmentChanged}
            inspectorDueDate={caseInfo.inspectorDueDate}
            caseType={caseType}
            controlNumber={controlNumber}
            preferredAppointment={caseInfo.preferredAppointmentDateAndTimeRange}
          />
        </Cell>
        {this.props.showAppraiserApprovalCard && caseHeader.appraisalAssignmentApprovalsExists &&
          <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
            <AppraiserAssignmentApproval controlNumber={controlNumber} setHasData={(resp) => this.setState({hasAppraisalSurveyInfo: resp})} />
          </Cell>
        }
        <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
          <SpecialAttentionNotes text={webNotes} />
        </Cell>
        <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
          <InspectionComments canUserEdit={caseHeader.canUserEdit} text={surveyRemarks} />
        </Cell>
        {caseLinks.length ? <Cell size={this.getCellSize(12)} tabletSize={12} phoneSize={12}>
          <PropertyCaseHistory
            caseLinks={caseLinks}
            fetchingCaseLinks={fetchingCaseLinks}
          />
        </Cell> : null}
        {(showHistory && this.props.canViewCaseHistoryList) && (
          <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
            <Card className="mcard card-unnested">
              <CardTitle title="History" className="mcard-title" />
              <CardText>
                {this.getHistoryControl()}
              </CardText>
            </Card>
          </Cell>
        )}
        {this.props.canViewQARejections && this.renderAppraisalQaRejection()}
      </div>
    );
  }
}

CaseHeader.propTypes = {
  controlNumber: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  verticalDisplay: PropTypes.bool,
  showHistory: PropTypes.bool,
  roles: PropTypes.array,
  displayAddressMap: PropTypes.func,

  // locally connected
  caseHeader: PropTypes.object.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
  updatingCaseHeader: PropTypes.bool,
  updateCaseHeader: PropTypes.func,
  getCaseHeader: PropTypes.func,

  FRList: PropTypes.array,
  isFetchingFRList: PropTypes.bool,
  getFRList: PropTypes.func,
  qaTouches: PropTypes.array,

  caseStepper: PropTypes.object,
  navigateToCase: PropTypes.func,
  openCaseTab: PropTypes.func,
  onQaRejectionRespondSave: PropTypes.func,

  caseLinks: PropTypes.array,
  getCaseLinks: PropTypes.func,
  fetchingCaseLinks: PropTypes.bool,

  viewInternalNotesInput: PropTypes.bool,
  showAppraiserApprovalCard: PropTypes.bool,
  showFRScheduleView: PropTypes.bool,
  showAppraiserScheduleView: PropTypes.bool,
  enabledFeatures: PropTypes.array,
  hasCaseAuditViewPermission: PropTypes.bool,
  canViewQARejections: PropTypes.bool,
  canViewCaseHistoryList: PropTypes.bool,
  canViewCasePropertyHistory: PropTypes.bool,
  canViewCasePropertyHistoryLimited: PropTypes.bool,
  getCaseLinksLimited: PropTypes.func,
};

// Connect
const mapStateToProps = state => {
  return {
    caseHeader: state.caseForms.caseHeader,
    fetchingHeader: state.caseForms.fetchingHeader,
    updatingCaseHeader: state.caseForms.updatingCaseHeader,
    FRList: state.fieldRep.fieldRepsBasicByCase,
    isFetchingFRList: state.fieldRep.isFetchingFieldReps,
    roles: state.user.profile.roles,
    caseStepper: state.caseStepper,
    caseLinks: state.caseLinks.caseLinks,
    fetchingCaseLinks: state.caseLinks.fetchingCaseLinks,
    viewInternalNotesInput: userHasRight(CASE_HISTORY_INTERNAL_NOTES_VIEW)(state),
    showAppraiserApprovalCard: userHasAnyRight(APPRAISAL_ASSIGNMENT_APPROVAL_EDIT, APPRAISAL_ASSIGNMENT_APPROVAL_VIEW)(state),
    showFRScheduleView: userHasRight(CASE_FR_SCHEDULE_VIEW)(state),
    showAppraiserScheduleView: userHasRight(CASE_APPRAISER_SCHEDULE_VIEW)(state),
    hasCaseAuditViewPermission: userHasRight(QA_CASE_AUDIT_VIEW)(state),
    canViewQARejections: userHasRight(QA_REJECTION_CARD_VIEW)(state),
    canViewCaseHistoryList: userHasRight(CASE_HISTORY_LIST_VIEW)(state),
    canViewCasePropertyHistory: userHasRight(CASE_PROPERTY_HISTORY_VIEW)(state),
    canViewCasePropertyHistoryLimited: userHasRight(CASE_PROPERTY_HISTORY_VIEW_LIMITED)(state),
  };
};
const mapDispatchToProps = dispatch => ({
  getCaseHeader(controlNumber) {
    dispatch(getCaseHeader(controlNumber));
  },
  updateCaseHeader(controlNumber, dto, callback = null) {
    dispatch(updateCaseHeader(controlNumber, dto, callback));
  },
  getFRList(controlNumber) {
    dispatch(getMinimalInspectorListByCase(controlNumber));
  },
  getCaseLinks(controlNumber) {
    dispatch(getCaseLinksRedux(controlNumber));
  },
  getCaseLinksLimited(controlNumber) {
    dispatch(getCaseLinksLimitedRedux(controlNumber));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps)(CaseHeader);
